import { createRootRoute, Outlet } from '@tanstack/react-router'
import Footer from '@ui/components/footer'

export const Route = createRootRoute({
  component: () => {
    return (
      <div className="flex flex-col min-h-screen w-full">
        <div className="flex-1 flex flex-col">
          <Outlet />
        </div>
        <Footer />
        {/* TODO: Re-enable chatbot when requested */}
        {/* <zapier-interfaces-chatbot-embed
          is-popup="true"
          chatbot-id="cmc6cb75n000hu7myligd73t4"
        ></zapier-interfaces-chatbot-embed> */}
      </div>
    )
  }
})
